export const QuoteFormResponseName = {
    FIRST_NAME: 'firstName',
    MIDDLE_NAME: 'middleName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PRIMARY_PHONE: 'primaryPhone',
    SALE_PRICE: 'salePrice',
    PURCHASE_PRICE: 'purchasePrice',
    TOTAL_LOAN_AMOUNT: 'totalLoanAmount',
    IS_FIRST_TIME_HOME_BUYER: 'firstTimeHomeBuyer',
    PROPERTY_TYPE: 'propertyType',
    IS_PROPERTY_IN_TORONTO: 'purchasingInToronto',
    TENANTS_LIVING_AT_PROPERTY: 'tenantsLivingAtProperty',
    TENANTS_LIVING: 'tenantsLiving',
    TENANTS_LIVING_IN_PROPERTY: 'tenantsLivingInProperty',
    IS_FAMILY_RESIDENCE: 'isFamilyResidence',
    CONTACT_ID: 'contactId',
    IS_PURCHASE_REQUIRE_MORTGAGE: 'mortgageRequired',
    IS_MORTGAGE_FOR_CONSTRUCTION: 'isMortgageBeingUsedToFinanceConstruction',
    HOW_WILL_YOU_BE_FINANCING: 'financingInstitute',
    SELECT_YOUR_LENDING_INSTITUTION: 'lendingInstitute',
    SPECIFY_YOUR_LENDER: 'specifyLender',
} as const;

export type QuoteFormResponseName =
    (typeof QuoteFormResponseName)[keyof typeof QuoteFormResponseName];

export const IntakeFormResponseName = {
    FIRST_NAME: 'firstName',
    TAKING_TITLE: 'takingTitleAs',
    MIDDLE_NAME: 'middleName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PRIMARY_PHONE: 'primaryPhone',
    SALE_PRICE: 'salePrice',
    PURCHASE_PRICE: 'purchasePrice',
    TOTAL_LOAN_AMOUNT: 'totalLoanAmount',
    DEPOSIT_GIVEN_PRICE: 'depositGivenPrice',
    APPROX_AMOUNT_OWING: 'approxAmountOwing',
    ADDITIONAL_QUESTIONS: 'additionalQuestions',
    CITIZENSHIP_STATUS: 'citizenshipStatus',
    CITY: 'city',
    CLOSING_DATE: 'closingDate',
    PURCHASE_CLOSING_DATE: 'purchaseClosingDate',
    DATE_OF_BIRTH: 'dateOfBirth',
    DEVELOPMENT_OR_RESALE: 'developmentOrResale',
    EMPLOYER: 'employer',
    EMPLOYER_ADDRESS: 'employerAddress',
    FIRST_ID: 'firstId',
    MARITAL_STATUS: 'maritalStatus',
    MORTGAGE_STATEMENT: 'mortgageStatement',
    OCCUPATION: 'occupation',
    POSTAL_CODE: 'postalCode',
    PRIMARY_RESIDENCE: 'primaryResidence',
    TENANTS_LIVING_AT_PROPERTY: 'tenantsLivingAtProperty',
    TENANTS_LIVING: 'tenantsLiving',
    TENANTS_LIVING_IN_PROPERTY: 'tenantsLivingInProperty',
    PROPERTY_TYPE: 'propertyType',
    PRIMARY_PLACE_OF_RESIDENCE: 'primaryPlaceOfResidence',
    PURCHASE_AND_SALE_AGREEMENT: 'purchaseAndSaleAgreement',
    RENTAL_ITEMS: 'rentalItems',
    SECOND_ID: 'secondId',
    SELLERS_LISTED_ON_PURCHASE_AND_SALE_AGREEMENT: 'sellersListedOnPurchaseAndSaleAgreement',
    SPOUSE_NAME: 'spouseName',
    STREET_NAME: 'streetName',
    STREET_NUMBER: 'streetNumber',
    SUBJECT_PROPERTY_ADDRESS: 'subjectPropertyAddress',
    TAX_BILL: 'taxBill',
    UNIT_NUMBER: 'unitNumber',
    EMPLOYER_PHONE_NUMBER: 'employerPhoneNumber',
    EMPLOYER_UNIT_NUMBER: 'employerUnitNumber',
    CURRENT_ADDRESS: 'currentAddress',
    CURRENT_UNIT_NUMBER: 'currentUnitNumber',
    MAILING_ADDRESS: 'mailingAddress',
    MAILING_UNIT_NUMBER: 'mailingUnitNumber',
    AFTER_CLOSING_ADDRESS: 'afterClosingAddress',
    AFTER_CLOSING_UNIT_NUMBER: 'afterClosingUnitNumber',
    MORTGAGE_REQUIRED: 'mortgageRequired',
    FINANCING_INSTITUTION: 'financingInstitute',
    LENDING_INSTITUTION: 'lendingInstitute',
    LENDER: 'specifyLender',
    RESALE_OR_NEW_DEVELOPMENT: 'resaleOrNewDevelopment',
    PURCHASERS_LISTED_ON_PURCHASE_AND_SALE_AGREEMENT: 'purchasersListedOnPurchaseAndSaleAgreement',
    IS_FIRST_TIME_HOME_BUYER: 'firstTimeHomeBuyer',
    NUMBER_OF_BORROWERS: 'borrowersList',
    MORTGAGE_AGREEMENT: 'mortgageAgreement',
    RECENT_TAX_BILL: 'recentTaxBill',
    VOID_CHEQUE: 'voidCheque',
    IS_FAMILY_RESIDENCE: 'isFamilyResidence',
    HOW_DID_YOU_FIND_US: 'howDidYouFindUs',
    ID_TYPE: 'idType',
} as const;

export type IntakeFormResponseName =
    (typeof IntakeFormResponseName)[keyof typeof IntakeFormResponseName];

export const IntakeFormGroupTitle = {
    INITIAL_DETAILS: 'Initial details',
    SELLER_INFORMATION: 'Seller(s) information',
    PURCHASER_INFORMATION: 'Purchaser(s) information',
    BORROWER_INFORMATION: 'Borrower(s) information',
    LENDER_INFORMATION: 'Lender(s) information',
    MAILING_INFO: 'Mailing info',
    CURRENT_ADDRESS: 'Current address',
    PROPERTY_DETAILS: 'Property Details',
} as const;

export type IntakeFormGroupTitle = (typeof IntakeFormGroupTitle)[keyof typeof IntakeFormGroupTitle];
